import { render, staticRenderFns } from "./ItemSetting.vue?vue&type=template&id=7de6a01e&scoped=true&"
import script from "./ItemSetting.vue?vue&type=script&lang=js&"
export * from "./ItemSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de6a01e",
  null
  
)

export default component.exports